import { defineRecipe } from '@chakra-ui/react';

export const textarea = defineRecipe({
  className: 'chakra-textarea',
  variants: {
    variant: {
      outline: {
        borderColor: 'gray.400',
        // height: 10,
        _hover: {
          borderColor: 'blue.300',
        },
        _focusVisible: {
          borderColor: 'blue.500',
          boxShadow: `0 0 0 1px var(--chakra-colors-blue-focus-ring)`, // blue.50
        },
      },
    },
    size: {
      md: {
        px: '4',
        height: 20,
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
